<template>
  <b-form-group :class="formGroupClass">
    <label v-if="!!$slots.default" :class="{'required': required}"><slot/></label>
    <b-form-select v-bind="$attrs"
                   :options="items"
                   :value="value"
                   :plain="true"
                   :class="addClass"
                   value-field="value"
                   text-field="text"
                   :disabled="disabled"
                   @input="$emit('input', $event)">
    </b-form-select>
  </b-form-group>
</template>

<script>
export default {
  name: 'SelectBox',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: () => false
    },
    addClass: {
      type: Object
    },
    required: false,
    formGroupClass: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style scoped>
.form-inline select.form-control {
  width: 100%;
}
select.form-control[size], select.form-control[multiple]{
  height: calc(1.5em + 0.75rem + 2px);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/SelectBox.vue